import { css, polished } from 'jimu-core';
export function expressionInputStyles(props) {
    const theme = props.theme;
    return css `
    .component-expression-input{
      font-size: ${theme.ref.typeface.fontSize};
      .input-wrapper{
        height: ${polished.rem(26)};
        padding-top: 0;
        padding-bottom: 0;
      }
      .disabled-input-cover{
        width: 100%;
        height: 100%;
        position: relative;
        top: -100%;
        &.ds-disabled{
          background-color: transparent;
        }
      }
      .ds-disabled{
        background-color: ${theme.ref.palette.neutral[300]};
        cursor: pointer;
        border: 0;
        >span.error-wrapper{
          color: ${theme.ref.palette.neutral[1200]};
          background-color: ${polished.rgba(theme.sys.color.error.main, 0.5)};
          vertical-align: sub;
          margin-left: 5px;
          margin-right: 5px;
        }
      }
      .ds-placeholder{
        >span{
          color: ${theme.ref.palette.neutral[900]};
          background-color: transparent;
        }
      }
      .expression-builder-trigger{
        cursor: pointer;
        width: 26px;
        height: 26px;
        padding: 0;
        .dropdown-button-content{
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .expression-builder-trigger-dropdown{
          padding: 0;
          .trigger-dropdown-toggle{
            background: ${theme.ref.palette.neutral[600]};
            border-radius: 2px 0 0 2px;
            border-color: ${theme.ref.palette.neutral[600]};
          }
        }
      }
      .expression-input{
        height: ${polished.rem(26)};
        .jimu-input, .ds-placeholder{
          border-radius: 0 2px 2px 0;
        }
      }
    }

  `;
}
